<template>
  <div>
    <section :class=getSelectThemeTypeCSSClasses>
      <div class="select-category__content">
        <h1>{{ getTranslations.home_select_theme_last_round_msg1 }}<br>{{ getTranslations.home_select_theme_last_round_msg2 }}</h1>
       <!-- <h1>{{ getTranslations.home_select_theme_wait_msg }}<br>{{ getTranslations.home_select_theme_wait_opponent }}</h1>-->
        <div class="select-category__content__icons">
          <div v-for="theme in themes" :key="theme.iconUrl" :class=getThemePlayedCSSClasses(theme)>
            <a href="#">
              <img :src="theme.iconUrl" alt="">
              <span class="cat-item__name">{{ theme.displayMultilanguageText }}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
    <div class="square-loader">
      <svg width="100%" height="100%">
        <rect width="100%" height="100%" style="fill:rgba(0,0,0,0);stroke:#3eb080" />
      </svg>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { squareLoaderAnimation } from '@/common/jQuery';

export default {
  name: 'selectThemeFreePlay',
  data() {
    return {
      themes: [],
      availableThemes: [],
      availableThemesHTMLElementIndices: [],
      selectedThemeID: null,
      timer: null,
    };
  },
  created() {
    this.themes = this.homePlayerCurrentThemes;
    let availableThemeIndex = 0;
    this.themes.forEach((theme) => {
      if (!theme.used) {
        if (this.isHomePlayer) {
          this.availableThemes.push(theme);
        }
        this.availableThemesHTMLElementIndices.push(availableThemeIndex += 1);
      }
    });
  },
  mounted() {
    console.log('in SelectTheme free play mounted hook');
    this.selectedThemeID = null;
    squareLoaderAnimation();
    // eslint-disable-next-line
    $(window).resize(() => squareLoaderAnimation());
    this.getSelectedTheme();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentSelectedTheme',
    ]),
    getSelectedTheme() {
      this.setPlayersCurrentSelectedTheme({
        homePlayerCurrentSelectedTheme: this.themes[0],
      });
      clearInterval(this.timer);
      this.normalTransition = true;
      setTimeout(() => {
        console.log('going to selectedTheme free play page');
        this.$router.replace('/trial/selectedTheme');
      }, 2000);
    },
    getThemePlayedCSSClasses(theme) {
      const classes = ['cat-item'];
      if (theme.used) {
        classes.push('played');
      }
      classes.push('cat-item-auto');
      return classes;
    },
  },
  computed: {
    ...mapState('game', [
      'homePlayerCurrentThemes',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getSelectThemeTypeCSSClasses() {
      const classes = ['select-category'];
      classes.push('select-category--waiting');
      return classes;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/SelectThemeFreePlay.vue